import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GonvarriOrderConsignedEntriesComponent } from '../../components/gonvarri-order-consigned-entries/gonvarri-order-consigned-entries.component';
import {GonvarriCartSharedModule} from "../gonvarri-cart-shared-module/gonvarri-cart-shared-module.module";
import {OrderDetailsModule} from "@spartacus/order/components";
import {FeaturesConfigModule, I18nModule, provideConfig} from "@spartacus/core";
import {OutletModule} from "@spartacus/storefront";
import {GonvarriAddToCartModule} from "../gonvarri-add-to-cart/gonvarri-add-to-cart.module";
import {AbstractOrderContextModule} from "@spartacus/cart/base/components";



@NgModule({
  declarations: [
    GonvarriOrderConsignedEntriesComponent
  ],
  exports: [
    GonvarriOrderConsignedEntriesComponent
  ],
  imports: [
    CommonModule,
    GonvarriCartSharedModule,
    OrderDetailsModule,
    I18nModule,
    OutletModule,
    GonvarriAddToCartModule,
    FeaturesConfigModule,
    AbstractOrderContextModule
  ],
  providers: [
    provideConfig({
      cmsComponents: {
        GonvarriOrderConsignedEntriesComponent: {
          component: GonvarriOrderConsignedEntriesComponent
        },
        OrderConsignedEntriesComponent: {
          component: GonvarriOrderConsignedEntriesComponent
        }
      }
    })
  ]
})
export class GonvarriOrderConsignedEntriesModule { }
